<template>
  <div class="automotive-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="automotive-content">
      <h4 class="automotive-h4 indent" id="automotive-1">АВТОМОБИЛОСТРОЕНЕ</h4>
      <p class="automotive-p indent">Потреблението на алуминий в автомобилостроенето нараства непрекъснато през последните 40 години, тъй като дава възможност на производителите да постигат все по-високите изисквания по отношение консумация на горива и контрол върху емисиите, като същевременно подобрява безопасността, ефективността и дизайна на автомобилите.</p>
      <p class="automotive-p indent">Алкомет произвежда профили по чертеж на клиента, както и богата гама от валцови продукти – листа, ленти и фолио, с приложения в автомобилостроенето.</p>
      <p class="automotive-p indent">Изпратете ни Вашето запитване още днес.</p>
      <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_1.jpg' + ')'}"></div>
      <h4 class="automotive-h4 indent" id="automotive-2">ЛЕНТИ ЗА ТОПЛООБМЕННИЦИ</h4>
      <p class="automotive-p indent">Със своите специфични свойства – отражателна способност, топлопроводимост и устойчивост на корозия – алуминият е идеален материал за топлоизолации, предлагайки отлична защита срещу топлината, отделяна от изпускателната система на автомобила. </p>
      <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_2.jpg' + ')'}"></div>
      <h4 class="automotive-h4 indent" id="automotive-3">ФИНСТОК ЗА АВТОМОБИЛИ</h4>
      <p class="automotive-p indent">Като изключително лек материал с добра топло- и електропроводимост,  алуминиевата лента за топлообменници (финсток) намира широко приложение в съвременните вентилационни и отоплителни системи.</p>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_3.jpg' + ')'}"></div> -->
      <h4 class="automotive-h4 indent" id="automotive-4">РЕЛСИ ЗА ПОКРИВИ</h4>
      <p class="automotive-p indent">Важно приложение за алуминиевите профили са релсите за покриви. Те се използват за пренасяне на допълнителен багаж и оборудване. Алуминиевите профили са най-подходящият избор, тъй като позволяват изграждането на визуално атрактивни, олекотени и същевременно здрави конструкции.</p>
      <h4 class="automotive-h4 indent" id="automotive-5">ДЕКОРАТИВНИ ЛАЙСНИ</h4>
      <p class="automotive-p indent"><strong>Декоративна лайсна</strong> се нарича всеки елемент, който се използва с цел подчертаване дизайна и елегантността на автомобила. Тези декоративни и същевременно функционални елементи играят важна роля за цялостния дизайн на автомобила.</p>
      <p class="automotive-p indent">В зависимост от използваната сплав могат да се използвати различини видове обработки на повърхността, вариращи от висок блясък до матов ефект, и от натурална до черна елоксация.</p>
      <p class="automotive-p indent">По тази причина съвременните автомобилни дизайнери залагат все по-често на алуминия за висококачествен decorative display and design purposes in the interior of today’s cars.</p>
      <router-link class="automotive-link" to="/contacts/factory-location">Изпратете ни Вашето запитване още днес.</router-link>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_4.jpg' + ')'}"></div> -->
      <h4 class="automotive-h4 indent" id="automotive-6">КЛИМАТИЧНИ СИСТЕМИ</h4>
      <p class="automotive-p indent">Алуминият е предпочитан материал за нарастващото разнообразие и високи изисквания при производството на климатична техника, като намира широко приложение също така в различни индустрии като автомобилостроенето за производство на различни топлообменници. Алуминият предлага уникална комбинация от преимущества здравина, корозионна устойчивост, възможност за допълнителни обработки.</p>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_5.jpg' + ')'}"></div> -->
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["automotive-1", "Автомобилостроене"],
        ["automotive-2", "Ленти за топлообменници"],
        ["automotive-3", "Финсток за автомобили"],
        ["automotive-4", "Релси за покриви"],
        ["automotive-5", "Декоративни лайсни"],
        ["automotive-6", "Климатични системи"],
      ]
    };
  }
};
</script>

<style scoped>
.automotive-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.automotive-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.automotive-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.automotive-link {
  font-size: 19px;
  text-decoration: underline;
}
.automotive-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.automotive-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .automotive-content {
    width: 100%;
  }
  .automotive-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .automotive-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .automotive-link {
    font-size: 16px;
  }
  .automotive-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Automotive.vue